import { render, staticRenderFns } from "./StudentLookup.vue?vue&type=template&id=2a2fd7e4&"
import script from "./StudentLookup.vue?vue&type=script&lang=js&"
export * from "./StudentLookup.vue?vue&type=script&lang=js&"
import style0 from "./StudentLookup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports